import type { PageStory } from '@/services/storyblok/storyblok'
import { StoryblokComponent, storyblokEditable } from '@storyblok/react'
import { main } from './PageBlock.css'

type Props = {
  blok: PageStory['content']
}

export const PageBlock = ({ blok }: Props) => {
  return (
    <>
      <main
        className={main}
        {...storyblokEditable(blok)}
        data-dark-background={!!blok.darkBackground}
        data-overlay-menu={!!blok.overlayMenu}
        data-hide-chat={!!blok.hideChat}
        data-header-mode="sticky"
      >
        {blok.body.map((nestedBlock) => (
          <StoryblokComponent blok={nestedBlock} key={nestedBlock._uid} />
        ))}
      </main>
    </>
  )
}
PageBlock.blockName = 'page'
